import { useSelector } from 'react-redux';
import { subscriptionTypeNames } from '../config/subscriptionsConfig';

export default function useIsAdmin() {
  const authState = useSelector(state => state.auth);
  const customClaims = authState?.user?.customClaims;

  if (!customClaims) return false;

  const { subscriptionType } = customClaims;

  const hasValidSubscription = [subscriptionTypeNames.admin].includes(subscriptionType);

  // isAdmin
  return hasValidSubscription;
}
